import axios from "axios";

export const reviewFetchDetails = async (recordId: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PROXY_URL}/v1/reviewSupplierTransferPackageUpload`,
      null,
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
        params: {
          record_id: recordId,
        },
      },
    );
    return response.data;
  } catch (e) {
    return null;
  }
};
